import Helper from '@ember/component/helper';
import { service } from '@ember/service';

export default class ParentTfos extends Helper {
  @service store;

  compute([parent_id, parent_key, hide_archive = true]) {
    const items = this.store
      .peekAll('tfo')
      .filter((item) => item[parent_key].get('id') === parent_id);
    if (hide_archive) {
      return items.filter((item) => !item.archived);
    }
    return items;
  }
}
